import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form, getIn } from 'formik';
import TextInput from 'components/inputs/Input';
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import moment from 'moment-timezone';
import * as Yup from 'yup';
import { FETCH_REPORT_LIST, CREATE_REPORT_DOWNLOAD_REQUEST } from 'actions/downloadAdvanceReport';
import { FETCH_CHARGING_STATION } from 'actions/chargingStation';
import { FETCH_ZONES } from 'actions/zoneManagement';
import { FETCH_USER } from 'actions/user';
import { FETCH_VEHICLE_MAKE } from 'actions/vehicleMake';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import { toast } from 'react-toastify';
import { BiPlus, BiTrash } from 'react-icons/bi';

const DownloadReportForm = ({ onClose = _.noop(), downloadReport = _.noop() }) => {
  const dispatch = useDispatch();

  // const [type, setType] = useState('');
  const [activeFilters, setActiveFilters] = useState([]);
  const [fields, setFields] = useState([
    { range: 5, condition: 'LessThan', type: 'mint' },
    { range: 0, condition: 'LessThan', type: 'unit' },
  ]);

  const searchOptions = [
    { label: 'Less Than or Equal To ≤', value: 'LessThan' },
    { label: 'Greater Than or Equal To ≥', value: 'GreaterThan' },
  ];
  const typeOptions = [
    { label: 'Unit Consumption', value: 'unit' },
    { label: 'Time Duration', value: 'mint' },
  ];

  const AdvanceReportSchema = Yup.object().shape({
    type: Yup.string().required('Type is required!'),
    name: Yup.string().required('Name is required!'),
    filter: Yup.object().shape({
      from: Yup.string().required('Start Date is required!'),
      to: Yup.string().required('End Date is required!'),
    }),
  });

  const reportList = useSelector((state) => state.reportList.reportList);
  // const allTags = useSelector((state) => state?.tagmanagement?.tags);
  const allStation = useSelector((state) => state?.chargingStation?.chargingStations);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const stationList =
    userProfileStations && userProfileStations.length > 0 ? allStation.filter((x) => userProfileStations.indexOf(x.id) !== -1) : allStation;

  const allZones = useSelector((state) => state?.zoneManagement?.zones);
  const zonePage = useSelector((state) => state?.zoneManagement?.page);
  const zoneTotalPage = useSelector((state) => state?.zoneManagement?.totalPages);

  const allUsers = useSelector((state) => state.user.users);
  const allVehicleMake = useSelector((state) => state.vehicleMake.vehicleMakes);

  const [fromDate, setFromDate] = useState('');

  const fetchReportList = useCallback((data) => {
    dispatch({
      type: FETCH_REPORT_LIST,
      payload: data,
    });
  }, []);

  const initialValues = {
    name: '',
    type: '',
    filter: {
      from: '',
      to: '',
    },
  };

  const createReportDownloadRequest = useCallback((data) => {
    const startTime = moment(data?.filter?.from);
    const endTime = moment(data?.filter?.to);
    const selectedTimeDiff = endTime.diff(startTime, 'days');
    const maxDays = data?.maxDay;
    const reportName = data?.name;
    data?.maxDay && delete data?.maxDay;
    dispatch({
      type: CREATE_REPORT_DOWNLOAD_REQUEST,
      payload: data,
      cb: (res) => {
        if (res) {
          console.log(res, 'response');
          if (_.get(res, 'status') === 200) {
            if (selectedTimeDiff > maxDays) {
              toast.success('Downloaded Successfully');
              setTimeout(() => {
                downloadReport({});
              }, 500);
            } else {
              fileDownload(res.data, `${reportName}.xlsx`);
              toast.success('Downloaded Successfully');
              setTimeout(() => {
                downloadReport({});
              }, 500);
            }
          }
        }
      },
    });
  }, []);

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      request_all: true,
    };
    dispatch({ type: FETCH_CHARGING_STATION, payload: stationData });
  }, []);

  const getAllZones = useCallback((data = {}) => {
    dispatch({ type: FETCH_ZONES, payload: data });
  }, []);

  const getAllUsers = useCallback((data) => {
    dispatch({
      type: FETCH_USER,
      payload: data ? data : null,
    });
  }, []);

  const getAllVehicleMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MAKE, payload: data });
  }, []);

  useEffect(() => {
    fetchReportList();
    getAllStation();
    getAllZones({ limit: 999 });
    getAllUsers({ role: 'doco', limit: 9999 });
    getAllVehicleMake({ limit: 999 });
  }, []);

  const handleFromDateChange = (val, setFieldValue) => {
    const dateValue = val.target.value;
    setFromDate(dateValue);
    setFieldValue('filter.from', dateValue);
  };

  const addField = () => {
    setFields([...fields, { range: '', condition: null, type: null }]);
  };

  const removeField = (index) => {
    const updatedFields = fields.filter((_, i) => i !== index);
    setFields(updatedFields);
  };

  const handleFieldChange = (index, key, value) => {
    setFields((prevFields) =>
      prevFields.map((field, i) => {
        if (i === index) {
          return key === 'type' ? { ...field, type: value, condition: null } : { ...field, [key]: value };
        }
        return field;
      })
    );
  };

  return (
    <React.Fragment>
      <div className="advance-report-form-page__main">
        <Card>
          <div className="advance-report-form-header__block">
            &nbsp;
            <div className="advance-report-header-name">
              <div className="advance-report-form-text-align">{'Generate Excel Report'}</div>
            </div>
            <div className="advance-close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
            &nbsp;
          </div>
          <div className="advance-report-form-body__block">
            <div className="advance-report-form--block">
              <Formik
                initialValues={initialValues}
                validationSchema={AdvanceReportSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const selectedType = _.find(reportList, { id: values.type });
                  const reportConfigs = {
                    FAILEDTRANSACTIONREPORT: {
                      status: ['completed'],
                      filter: fields,
                      reportFormat: 'excel',
                    },
                    STATIONCHARGINGSUMMARY: {
                      reportFormat: 'excel',
                    },
                    PARTNERCHARGINGSESSIONS: {
                      reportFormat: 'excel',
                    },
                    CHARGINGSESSIONREPORT: {
                      reportFormat: 'excel',
                    },
                    CHARGETRANSACTIONREPORT: {
                      reportFormat: 'excel',
                    },
                  };

                  const selectedReportKey = selectedType?.key;
                  const extraFilterFields = reportConfigs[selectedReportKey] || {};

                  const reportData = {
                    ...values,
                    maxDay: selectedType?.max_days,
                    filter: {
                      ...values.filter,
                      from: moment.tz(values.filter.from, 'Asia/Dubai').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
                      to: moment.tz(values.filter.to, 'Asia/Dubai').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
                      ...extraFilterFields,
                    },
                  };
                  setTimeout(() => {
                    createReportDownloadRequest(reportData);
                    setSubmitting(false);
                    onClose();
                  }, [500]);
                }}
              >
                {({ values, handleSubmit, setFieldValue, handleChange, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={6}>
                        <Select
                          isRequired
                          label={'Select Report Type'}
                          options={[
                            ..._.map(reportList, (item) => {
                              return { label: item.name, value: item.id };
                            }),
                          ]}
                          placeholder={'Select Report Type'}
                          name="type"
                          value={values.type}
                          onMenuScrollDown={true}
                          onChange={(val) => {
                            setFieldValue(`type`, val);
                            const selectedType = _.find(reportList, { id: val });
                            setActiveFilters(_.get(selectedType, 'filter', []));
                            // setType(_.get(selectedType, 'key', ''));
                            setFieldValue(`filter`, '');
                          }}
                          error={getIn(errors, 'type') && getIn(touched, 'type') ? getIn(errors, 'type') : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <TextInput
                          isRequired
                          label={'Report Name'}
                          placeholder={'Enter Report Name'}
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          error={getIn(errors, 'name') && getIn(touched, 'name') ? getIn(errors, 'name') : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <span className="font-color">{'Start Date'}</span>
                        <div>&nbsp;</div>
                        <div className="time_sec">
                          <span className="custome_time">
                            <input
                              className="ct_selecter"
                              type="date"
                              value={values.filter.from}
                              max={moment().format('YYYY-MM-DD')}
                              onChange={(val) => handleFromDateChange(val, setFieldValue)}
                            />
                            <div style={{ color: '#dc4949', fontSize: 10 }}>
                              {getIn(errors, 'filter.from') && getIn(touched, 'filter.from') ? getIn(errors, 'filter.from') : null}
                            </div>
                          </span>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <span className="font-color">{'End Date'}</span>
                        <div>&nbsp;</div>
                        <div className="time_sec">
                          <span className="custome_time">
                            <input
                              className="ct_selecter"
                              disabled={!fromDate}
                              type="date"
                              placeholder={'Select Date & Time'}
                              value={values.filter.to || ''}
                              min={fromDate}
                              max={moment().format('YYYY-MM-DD')}
                              onChange={(val) => {
                                setFieldValue(`filter.to`, val.target.value);
                              }}
                            />
                            <div style={{ color: '#dc4949', fontSize: 10 }}>
                              {getIn(errors, 'filter.to') && getIn(touched, 'filter.to') ? getIn(errors, 'filter.to') : null}
                            </div>
                          </span>
                        </div>
                      </Col>
                      {activeFilters.includes('Company') && (
                        <Col lg={6}>
                          <Select
                            label="Company"
                            options={_.map(allUsers, (item) => {
                              return { label: item.company, value: item.id };
                            })}
                            placeholder="Select Company"
                            name="filter.company"
                            value={values.filter.company}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue(`filter.company`, val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Vehicle Brand') && (
                        <Col lg={6}>
                          <Select
                            label="Vehicle Brand"
                            options={_.map(allVehicleMake, (item) => {
                              return { label: item.name, value: item.name };
                            })}
                            placeholder="Select Vehicle Brand"
                            name="filter.make"
                            value={values.filter.make}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue(`filter.make`, val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Station') && (
                        <Col lg={6}>
                          <Select
                            label={'Station'}
                            options={[
                              ..._.map(stationList, (station) => {
                                return { label: station.name, value: station.id };
                              }),
                            ]}
                            placeholder={`Station Name`}
                            name="filter.charging_station"
                            value={values.filter.charging_station}
                            isMulti
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue(`filter.charging_station`, val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Zones') && (
                        <Col lg={6}>
                          <Select
                            label="Zones"
                            isMulti
                            options={_.map(allZones, (item) => {
                              return { label: item.name, value: item.id };
                            })}
                            className="filter-select-box"
                            placeholder="Select Zones"
                            name="filter.zones"
                            value={values.filter.zones}
                            onMenuScrollDown={true}
                            getDataOnScrollDown={getAllZones}
                            page={zonePage}
                            totalPage={zoneTotalPage}
                            onChange={(val) => {
                              setFieldValue('filter.zones', val);
                            }}
                          />
                        </Col>
                      )}

                      {activeFilters.includes('Range') && (
                        <>
                          {fields.map((field, index) => {
                            return (
                              <>
                                <Row key={index}>
                                  <Col xl={4} md={12}>
                                    <Select
                                      placeholder="Select Type"
                                      options={typeOptions}
                                      value={field.type}
                                      onChange={(e) => handleFieldChange(index, 'type', e)}
                                    />
                                  </Col>
                                  <Col xl={3} md={12}>
                                    <TextInput
                                      placeholder="Enter Range"
                                      type="number"
                                      value={parseFloat(field.range)}
                                      onChange={(e) => handleFieldChange(index, 'range', parseFloat(e.target.value))}
                                    />
                                  </Col>
                                  <Col xl={4} md={12}>
                                    <Select
                                      placeholder="Select Condition"
                                      options={searchOptions.filter((option) => {
                                        if (option.value === field.condition) return true;

                                        const selectedType = field.type;
                                        if (!selectedType) return true;

                                        const isAlreadyUsed = fields.some(
                                          (f, i) => f.type === selectedType && f.condition === option.value && i !== index
                                        );

                                        return !isAlreadyUsed;
                                      })}
                                      value={field.condition}
                                      onChange={(e) => handleFieldChange(index, 'condition', e)}
                                    />
                                  </Col>
                                  <Col xl={'auto'} md={'auto'}>
                                    <Button className="field--btn" onClick={() => removeField(index)}>
                                      <BiTrash size={26} />
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            );
                          })}
                          {fields.length !== 4 ? (
                            <Row>
                              <Col xl={2} md={2}>
                                <Button className="field--btn" onClick={addField}>
                                  <BiPlus size={22} className="plus--icon" />
                                  Add
                                </Button>
                              </Col>
                            </Row>
                          ) : null}
                        </>
                      )}
                    </Row>
                    <div className="advance-report-input-box__block">
                      <Row>
                        <Col lg={6}>
                          <Button className="advance--btn cancel--btn" onClick={onClose}>
                            {'Cancel'}
                          </Button>
                        </Col>
                        <Col lg={6}>
                          <Button type="submit" className="advance--btn  remove--btn" onClick={handleSubmit}>
                            {'Download'}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
DownloadReportForm.propTypes = {
  onClose: PropTypes.func,
  downloadReport: PropTypes.func,
};
export default DownloadReportForm;
